/*
 * @Author: none
 * @Date: 2022-03-09 13:24:03
 * @LastEditors: niyingfeng
 * @LastEditTime: 2022-03-11 17:36:38
 * @FilePath: /cheese/web/src/cheese-home/vuex/actions.js
 * @Description: 处理http实例
 * 
 */
import http from 'g-public/apis/http';
import { FETCH_BANNER, SET_BANNER, SET_BANNER_ERRORINFO } from './types';
import { BANNER_TYPE2NUM } from '../enum';
import { webpImg } from 'g-public/utils';

// const debug = require('debug')('app:cheese:actions');

export default {
    async [FETCH_BANNER]({ commit }, payload) {
        const response = await http.get('pugv/app/web/zone/banner', {
            headers: payload.headers
        })

        if (response.status === 200 && response.data.code === 0) {
            const banners = response.data.data.banner;
            // const banners = [];
            const bannersResourceId = response.data.data.resource_id;

            if (!banners || !banners.length) {
                commit(SET_BANNER_ERRORINFO, {
                    url: 'pugv/app/web/zone/banner',
                    http: response.data
                });
                return;
            };

            const epIds = banners.filter(banner => banner.type === BANNER_TYPE2NUM.video).map(item => item.ep_id);

            // 鉴权判断是否能播放
            const response2 = await http({
                method: 'get',
                url: 'pugv/app/web/ep/paystatus',
                headers: payload.headers,
                params: {
                    ep_ids: epIds.toString()
                }
            });

            if (response2.status === 200 && response2.data.code === 0) {
                const data = response2.data.data;
                if (!data) {
                    commit(SET_BANNER_ERRORINFO, {
                        url: 'pugv/app/web/ep/paystatus',
                        http: response2.data
                    });
                    return;
                }

                // 1=可试看， 2=不可试看
                for (let key in data) {
                    key = Number(key);
                    const target = banners.filter(banner => banner.ep_id === key);
                    if (!target.length) return;
                    target[0].status = data[key];
                }
                // 图片http截断处理
                banners.forEach(banner => {
                    banner.img = webpImg(banner.img, 978 * 2, 550 * 2, true);
                });
                // debug('banner加入鉴权数据:', banners);
                commit(SET_BANNER, {banners, bannersResourceId});
                return banners;
            }

            return [];
        }

    }
};
